import { useState } from "react";
import {
    Box, Button, Card, CardContent, CircularProgress,
    TextField, Typography, Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!isValidEmail) return;
        setLoading(true);
        setError(null);
        try {
            await authService.sendPasswordReset(email);
            setSuccess(true);
        } catch {
            setError("Bir hata oluştu. Lütfen tekrar deneyin.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f2f5" }}>
            <Card sx={{ width: 400, borderRadius: 3, boxShadow: 3 }}>
                <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                        <Box component="img" src="/sensify-iot.png" alt="Sensify IoT" sx={{ height: 48 }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600} textAlign="center" mb={1} color="#1a1a1a">
                        Şifremi Unuttum
                    </Typography>
                    <Typography variant="body2" textAlign="center" mb={3} color="text.secondary">
                        E-posta adresinizi girin, şifre sıfırlama bağlantısı gönderelim.
                    </Typography>

                    {success ? (
                        <Alert severity="success" sx={{ mb: 2 }}>
                            Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.
                        </Alert>
                    ) : (
                        <>
                            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                            <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField
                                    label="E-posta"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    autoFocus
                                    fullWidth
                                    size="small"
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    disabled={loading || !isValidEmail}
                                    sx={{ mt: 1, py: 1.2, textTransform: "none", fontWeight: 600, backgroundColor: "var(--color-primary, #1976d2)" }}
                                >
                                    {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Bağlantı Gönder"}
                                </Button>
                            </Box>
                        </>
                    )}

                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate("/login")}
                            sx={{ textTransform: "none", color: "text.secondary" }}
                        >
                            Giriş sayfasına dön
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ForgotPassword;
